module.exports = "<p>\n  maps works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/maps/maps-home.component.html
// module id = ./src/app/maps/maps-home.component.html
// module chunks = 0